/**
 * Shared wording for the sub-contractor induction form AND its PDF, so
 * the ticks printed on the PDF always line up with what was ticked.
 * (Before Sep 2026 the PDF had its own, differently-ordered labels.)
 */

export const SUBBIE_INSURANCE = [
  'Public Liability — covers them if work damages something or hurts a member of the public',
  "Employers' Liability — only if they have anyone working under them",
  "Professional Indemnity — only if they're doing design / consultancy",
];

export const SUBBIE_COMPETENCE = [
  'Cards / training relevant to their work (CSCS, First Aid, Asbestos awareness etc.)',
  "RAMS for today's job has been read and signed",
  "COSHH info given for any chemicals they're bringing",
  "I've checked references or past work — happy to use them",
];

/** What the inductee was briefed on. CDM 2015 reg. 13(4)(c): the
 *  Principal Contractor must give everyone a suitable site induction. */
export const INDUCTION_TOPICS = [
  'Site rules, working hours and sign-in / sign-out',
  'Fire alarm, escape routes and assembly point',
  'First aid — first-aiders, kit location and nearest A&E',
  'Welfare facilities',
  'Site-specific hazards and no-go / restricted areas',
  'PPE required on this site',
  'Traffic routes, pedestrian routes and plant',
  'Permits to work (hot works, digging, confined spaces)',
  'Asbestos and other hazardous materials on this site',
  'Their RAMS briefed and understood',
  'How to report accidents, near misses and hazards',
  'How to raise H&S concerns and who the site manager is',
  'Housekeeping, waste and storage of materials',
];

export const INDUCTION_DECLARATION = [
  'I have received and understood the site induction.',
  'I will follow the site rules, my RAMS and the instructions of the site manager.',
  'I will report all accidents, near misses and hazards immediately.',
  'I will provide updated RAMS if the scope of my work changes.',
  'Anyone working under me will be inducted and provide the same paperwork before starting.',
];

export const CARD_TYPES = ['', 'CSCS', 'CPCS', 'NPORS', 'CISRS', 'ECS', 'JIB / PMES', 'Other', 'None held'];
